import React from 'react';
export function AdvertorialFooter() {
  return <footer className="bg-[#1F2937] text-gray-300 py-12 font-sans mt-16" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-3">
          <div className="col-span-1 md:col-span-1" data-id="element-4">
            <div className="flex items-center gap-2 mb-4" data-id="element-5">
              <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center text-[#1F2937] font-bold text-xl" data-id="element-6">
                B
              </div>
              <span className="font-bold text-white text-xl" data-id="element-7">Barkvee</span>
            </div>
            <p className="text-sm text-gray-400" data-id="element-8">
              Dedicated to improving mobility and comfort for active seniors
              through innovative home solutions.
            </p>
          </div>

          <div data-id="element-9">
            <h4 className="font-bold text-white mb-4" data-id="element-10">Company</h4>
            <ul className="space-y-2 text-sm" data-id="element-11">
              <li data-id="element-12">
                <a href="#" className="hover:text-white transition-colors" data-id="element-13">
                  About Us
                </a>
              </li>
              <li data-id="element-14">
                <a href="#" className="hover:text-white transition-colors" data-id="element-15">
                  Our Story
                </a>
              </li>
              <li data-id="element-16">
                <a href="#" className="hover:text-white transition-colors" data-id="element-17">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-18">
            <h4 className="font-bold text-white mb-4" data-id="element-19">Support</h4>
            <ul className="space-y-2 text-sm" data-id="element-20">
              <li data-id="element-21">
                <a href="#" className="hover:text-white transition-colors" data-id="element-22">
                  Contact Us
                </a>
              </li>
              <li data-id="element-23">
                <a href="#" className="hover:text-white transition-colors" data-id="element-24">
                  FAQ
                </a>
              </li>
              <li data-id="element-25">
                <a href="#" className="hover:text-white transition-colors" data-id="element-26">
                  Returns
                </a>
              </li>
              <li data-id="element-27">
                <a href="#" className="hover:text-white transition-colors" data-id="element-28">
                  Shipping
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-29">
            <h4 className="font-bold text-white mb-4" data-id="element-30">Legal</h4>
            <ul className="space-y-2 text-sm" data-id="element-31">
              <li data-id="element-32">
                <a href="#" className="hover:text-white transition-colors" data-id="element-33">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-34">
                <a href="#" className="hover:text-white transition-colors" data-id="element-35">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-36">
                <a href="#" className="hover:text-white transition-colors" data-id="element-37">
                  Disclaimer
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 text-center text-xs text-gray-500" data-id="element-38">
          <p className="mb-2" data-id="element-39">
            *The information presented on this website is not intended as
            specific medical advice and is not a substitute for professional
            medical treatment or diagnosis. These statements have not been
            evaluated by the Food and Drug Administration. This product is not
            intended to diagnose, treat, cure, or prevent any disease.
          </p>
          <p data-id="element-40">
            &copy; {new Date().getFullYear()} Barkvee Health. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}